const storageKey = "sessionId"

export function GetSessionID() : string | null {
    return sessionStorage.getItem(storageKey);
}

export function SetSessionID(sessionId:string) {
    sessionStorage.setItem(storageKey, sessionId);
}

export function RemoveSessionID() {
    sessionStorage.removeItem(storageKey);
}

export function IsExistSessionID() {
    return GetSessionID !== null
}

export interface ConfirmSessionType {
    session_result: boolean
}

export async function GetConfirmSession() : Promise<ConfirmSessionType | undefined> {

    if(!IsExistSessionID()) {
        return(undefined);
    }

    const getAddress = `/competition/api/session/confirmSession?sessionId=${GetSessionID()}`

    const result = await fetch(getAddress)
    .then(res => {
        return(res.ok ? res.json() : undefined); 
    })
    .catch(err => {
        console.error(err);
        return undefined;
    })

    return (result);

}

export async function PostDeleteSession() : Promise<boolean> {

    if(!IsExistSessionID()) {
        return(false);
    }

    const getAddress = `/competition/api/session/deleteSession?sessionId=${GetSessionID()}`

    const result = await fetch(getAddress, {
        method:"POST"
    })
    .then(res => {
        return res.ok
    })
    .catch(err => {
        console.error(err);
        return false;
    })

    return (result);

}